import { KategoriEklePage } from './../kategori-ekle/kategori-ekle';


import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { Ortak } from './../../../../providers/ortak';
import { BllOrtak } from './../../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the KategoriListePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-kategori-liste',
  templateUrl: 'kategori-liste.html',
})
export class KategoriListePage {
  aranan="";
  skip:number=0;
  take:number=100;
  KategoriListesi=[];

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public modalCtrl:ModalController,
     public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.kayitAra(null);
  }
  kayitAra(e) {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "KategoriListesi","", false).then(a => {
     
      var sonuc = <any>a;
      this.KategoriListesi = sonuc.SonucObject;
   
   
 
    })
  }
  
  birimkayitlari(e) {

    if (e.keyCode == 13) {
      this.kayitAra(e);
    }
  }
  yenikayit() {
    let modal = this.modalCtrl.create(KategoriEklePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();

  }
  kayitduzenle(kategori){
    let modal = this.modalCtrl.create(KategoriEklePage, { kategoriVw: kategori });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
   
  }
  KategoriSil(kategori) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      
      formData.append("ID", kategori.ID);

      this.bllOrtak.islem(formData, "KategoriSil", "", true).then(a => {

      }).catch(x => {

        this.ortak.showErrorAlert();
      })
      this.kayitAra("");
     
    })
   
  }


}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/KategoriIslemleri/kategori-liste/kategori-liste.ts